import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ParStatus from './par-status';
import ParStatusDetail from './par-status-detail';
import ParStatusUpdate from './par-status-update';
import ParStatusDeleteDialog from './par-status-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ParStatusUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ParStatusUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ParStatusDetail} />
      <ErrorBoundaryRoute path={match.url} component={ParStatus} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ParStatusDeleteDialog} />
  </>
);

export default Routes;
